/** @format */

import { posVersionUrl } from "../Config/Url";
import axios from "axios";

export const posVersionService = {
  getAll,
  create,
  update,
  remove,
  posAddToSelectedVersion,
  posAddToSelectedIctVersion,
  posAddToSelectedToTenantVersion,
  posAddToSelectedToAllVersion,
  reporting,
  reportingUsage,
};

async function getAll() {
  return axios
    .put(`${posVersionUrl}/search`, { pageIndex: 0, pageSize: 100 })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create(name, isCurrent) {
  return axios
    .post(`${posVersionUrl}`, { name, isCurrent })
    .then((res) => res)
    .catch((err) => err.response);
}

async function update(id, name, isCurrent) {
  return axios
    .put(`${posVersionUrl}/${id}/set-current`, { posVersionId: id })
    .then((res) => res)
    .catch((err) => err.response);
}

async function remove(id) {
  return axios
    .delete(`${posVersionUrl}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function posAddToSelectedVersion(posVersionId, data) {
  return axios
    .post(`${posVersionUrl}/add`, { posVersionId, data })
    .then((res) => res)
    .catch((err) => err.response);
}

async function posAddToSelectedIctVersion(posVersionId, typeId, posIds) {
  return axios
    .post(`${posVersionUrl}/add-by-ict`, { posVersionId, typeId, data: posIds })
    .then((res) => res)
    .catch((err) => err.response);
}
async function posAddToSelectedToTenantVersion(posVersionId, tenantId) {
  return axios
    .post(`${posVersionUrl}/add-to-tenant`, { posVersionId, tenantId })
    .then((res) => res)
    .catch((err) => err.response);
}

async function posAddToSelectedToAllVersion(posVersionId) {
  return axios
    .post(`${posVersionUrl}/add-to-all`, { posVersionId })
    .then((res) => res)
    .catch((err) => err.response);
}

async function reportingUsage(dateFrom, dateTo) {
  return axios
    .put(`${posVersionUrl}/reporting-usage`, { from: dateFrom, to: dateTo })
    .then((res) => res)
    .catch((err) => err.response);
}

async function reporting(version, validFrom, fromDayToNow) {
  return axios
    .put(`${posVersionUrl}/reporting`, {
      day: validFrom,
      version,
      fromDayToNow,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
